import { useInView } from '../hooks/useInView';
import { visaServices } from '../data/mock';
import { FileText, Briefcase, Plane, Globe, Heart, ArrowRight } from 'lucide-react';

const iconMap = { FileText, Briefcase, Plane, Globe, Heart };

export const VisaServicesSection = () => {
  const [ref, isInView] = useInView();

  return (
    <section id="visa-services" className="relative py-24 bg-white overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4A853]/30 to-transparent" />
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#D4A853]/5 rounded-full blur-[100px] pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#243B6A]/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        {/* Section Header */}
        <div
          className={`text-center mb-16 transition-[opacity,transform] duration-700 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="text-[#D4A853] font-semibold text-sm uppercase tracking-[0.2em]">Visa Services</span>
          <h2
            className="text-4xl sm:text-5xl font-bold text-[#0A1628] mt-3 mb-5"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Complete Visa Solutions
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto leading-relaxed">
            From student visas to family visit visas, we handle every type of visa application with expertise and care.
          </p>
        </div>

        {/* Visa Service Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {visaServices.map((service, index) => {
            const Icon = iconMap[service.icon] || FileText;
            return (
              <div
                key={service.title}
                className={`group relative bg-[#F8FAFC] rounded-2xl p-6 border border-slate-100 hover:border-[#D4A853]/30 cursor-pointer card-tilt transition-[opacity,transform,border-color,box-shadow] duration-500 hover:shadow-xl hover:shadow-[#0A1628]/5 ${
                  isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 80}ms` }}
              >
                <div className="w-12 h-12 bg-[#0A1628] rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#D4A853] transition-colors duration-400">
                  <Icon className="w-6 h-6 text-[#E8C87A] group-hover:text-[#0A1628] transition-colors duration-400" />
                </div>
                <h3 className="font-bold text-[#0A1628] mb-1.5 text-[15px]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {service.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">{service.description}</p>
                <ArrowRight className="w-4 h-4 text-[#D4A853] mt-3 group-hover:translate-x-1 transition-transform duration-300" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
